import { withKey, withoutKey } from 'piral-core';
export function registerTile(ctx, name, value) {
    ctx.dispatch((state) => (Object.assign(Object.assign({}, state), { registry: Object.assign(Object.assign({}, state.registry), { tiles: withKey(state.registry.tiles, name, value) }) })));
}
export function unregisterTile(ctx, name) {
    ctx.dispatch((state) => (Object.assign(Object.assign({}, state), { registry: Object.assign(Object.assign({}, state.registry), { tiles: withoutKey(state.registry.tiles, name) }) })));
}
//# sourceMappingURL=actions.js.map